import React, { useState, useEffect, useContext, createContext } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permisos, setPermisos] = useState(null);
  const [loading, setLoading] = useState(true);

  const cargarPermisos = async () => {
    try {
      const r = await api.get('/me/permisos');
      setPermisos(r.data.permisos || {});
      return r.data.permisos || {};
    } catch { setPermisos({}); return {}; }
  };

  useEffect(() => {
    const token = localStorage.getItem('app_token');
    if (token) {
      api.get('/auth/me')
        .then(async (res) => {
          setUser(res.data);
          if (['admin', 'colaborador', 'gestoria', 'auditor'].includes(res.data?.role)) {
            await cargarPermisos();
          }
        })
        .catch(() => localStorage.removeItem('app_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    localStorage.setItem('app_token', res.data.access_token);
    setUser(res.data.user);
    if (['admin', 'colaborador', 'gestoria', 'auditor'].includes(res.data.user?.role)) {
      await cargarPermisos();
    }
    return res.data.user;
  };

  const register = async (payload) => {
    const res = await api.post('/auth/registro', payload);
    localStorage.setItem('app_token', res.data.access_token);
    setUser(res.data.user);
    if (['admin', 'colaborador', 'gestoria', 'auditor'].includes(res.data.user?.role)) {
      await cargarPermisos();
    }
    return res.data.user;
  };

  const refreshUser = async () => {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data);
      return res.data;
    } catch {
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem('app_token');
    setUser(null);
    setPermisos(null);
  };

  const puede = (modulo) => {
    if (user?.role === 'admin') return true;
    if (!permisos) return true; // Todavía cargando: no bloquear
    return !!permisos[modulo];
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, refreshUser, permisos, puede, cargarPermisos }}>
      {children}
    </AuthContext.Provider>
  );
};
